import "./WaterLeakProblems.module.css";
import Header from "@/reusable_sections/Header";
import LeakOverview from "./sections/LeakOverview";
import LeakSymptoms from "./sections/LeakSymptoms";
import Coverage from "./sections/Coverage";
import Footer from "@/reusable_sections/Footer";
export default function WaterLeakProblemsPage() {
  return <div>
      <Header />
      <LeakOverview />
      <LeakSymptoms />
      <Coverage />
      <Footer />
    </div>;
}